export default [
  {
    path: 'mi-plan',
    component: () => import('@/views/empresa/suscripcion/MiPlanLayout.vue'),
    children: [
      {
        path: '',
        name: 'empresa.miPlan',
        component: () => import('@/views/empresa/suscripcion/MiPlan.vue'),
      },
    ],
  },
]
